import { connectLean } from 'lean-redux';
import merge from 'lodash/merge';

const withConnectLean = connectLean({
  scope: 'units',
  mapState(unitsState, ownProps) {
    const { assignmentSectionId, videos } = ownProps;
    const userClassIds = [assignmentSectionId];
    const { availableResourceIds, availableUnitIds } = (videos || []).reduce(
      (acc, video) => {
        const { id, unitId } = video;
        acc.availableResourceIds.push(id);
        acc.availableUnitIds.push(unitId);

        return acc;
      },
      {
        availableResourceIds: [],
        availableUnitIds: [],
      },
    );

    const unitKeys = Object.keys(unitsState).filter((unitKey) =>
      availableUnitIds.includes(unitKey.split('-')[1]),
    );
    const isAssignedAtLeastOnce = unitKeys.some((unitKey) => {
      const unitData = unitsState[unitKey] || {};
      const resourceKeys = Object.keys(unitData.resources || {});

      return resourceKeys
        .filter((resourceKey) => {
          const resourceId = resourceKey.split('-')[1];
          return availableResourceIds.includes(resourceId);
        })
        .some((resourceKey) => {
          const { savedClasses } = unitData.resources[resourceKey];
          const userContextSavedClasses = (savedClasses || []).filter(
            (sectionId) => userClassIds.includes(sectionId),
          );
          return userContextSavedClasses.length > 0;
        });
    });

    return {
      isAssignedAtLeastOnce,
    };
  },
  setVideoResourcesAssignedClasses(
    masterSubjectId,
    videos,
    resourcesWithAssignedClasses,
    watchedVideoIds,
    callback,
  ) {
    const units = videos.reduce((acc, video) => {
      const { id, unitId } = video;
      const videoAssignedClassIds =
        (
          resourcesWithAssignedClasses.find(
            (resource) => resource.id === video.id,
          ) || {}
        ).classIds || [];
      const unitKey = `unit-${unitId}`;
      const resourceKey = `resource-${id}-subject-${masterSubjectId}`;
      const resourceData = {
        isDisabled: false,
        savedClasses: videoAssignedClassIds,
        selectedItems: videoAssignedClassIds,
        withWatchedVideo: (watchedVideoIds || []).includes(id),
      };

      if (acc[unitKey]) {
        acc[unitKey].resources[resourceKey] = resourceData;
      } else {
        acc[unitKey] = {
          resources: {
            [resourceKey]: resourceData,
          },
        };
      }

      return acc;
    }, {});

    this.setState((prevState) => merge(prevState, units), callback);
  },
});

export default withConnectLean;
